import { Button as MuiButton, CircularProgress, useTheme } from '@mui/material';
import { tokens } from '../theme';

export function Button({
  children,
  loading = false,
  disabled = false,
  fullWidth = true,
  type = 'button',
  variant = 'contained',
  onClick,
  sx,
  startIcon,
  endIcon,
  ...props
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const baseStyles = {
    fontWeight: 600,
    fontFamily: 'Ubuntu, sans-serif',
    py: '14px',
    px: '32px',
    borderRadius: '4px',
    textTransform: 'none',
    fontSize: '12px',
    transition: 'all 0.2s',
    position: 'relative',

    '&.Mui-disabled': {
      opacity: 0.5,
    },
  };

  const variantStyles = {
    contained: {
      backgroundColor: colors.greenAccent[500],
      color: colors.grey[200],

      '&:hover': {
        backgroundColor: '#72c73d',
      },

      '&:active': {
        backgroundColor: '#62b82d',
      },
    },

    outlined: {
      backgroundColor: '#fff',
      color: colors.greenAccent[500],
      border: '1px solid #83d84d',

      '&:hover': {
        backgroundColor: '#f6fff0',
        borderColor: colors.greenAccent[500],
      },

      '&:active': {
        backgroundColor: '#ecffe0',
      },
    },

    text: {
      color: colors.greenAccent[500],

      '&:hover': {
        backgroundColor: 'rgba(131, 216, 77, 0.08)',
      },
    },
  };

  return (
    <MuiButton
      disableElevation
      type={type}
      variant={variant}
      onClick={onClick}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
      sx={[baseStyles, variantStyles[variant], sx]}
      {...props}
    >
      {loading && (
        <CircularProgress
          size={18}
          color="inherit"
          sx={{
            position: 'absolute',
          }}
        />
      )}

      <span style={{ opacity: loading ? 0 : 1 }}>{children}</span>
    </MuiButton>
  );
}
